import { Suspense } from 'react';
import { ArtifactSurfaces } from 'breeze-artifacts-sdk/types';
import { getContributionsForSurface } from 'breeze-artifacts-sdk/registry';
import { PluginErrorBoundary } from 'breeze-artifacts-sdk/renderers/PluginErrorBoundary';
import DefaultArtifactChip from 'breeze-artifacts-sdk/chip/DefaultArtifactChip';
import { jsx as _jsx } from "react/jsx-runtime";
const ArtifactChip = props => {
  const contribution = getContributionsForSurface(props.artifact.artifactType, ArtifactSurfaces.CHIP);
  if (!contribution || contribution.surface !== ArtifactSurfaces.CHIP) {
    return /*#__PURE__*/_jsx(DefaultArtifactChip, Object.assign({}, props));
  }
  const ChipComponent = contribution.component;
  return /*#__PURE__*/_jsx(PluginErrorBoundary, {
    fallback: /*#__PURE__*/_jsx(DefaultArtifactChip, Object.assign({}, props)),
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(ChipComponent, Object.assign({}, props))
    })
  });
};
export default ArtifactChip;